"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButtons = void 0;
var _openShadePicker = require("@ori-events/open-shade-picker");
var _favoritesHeart = require("@ori/favorites-heart");
var _presentationComponents = require("@ori/presentation-components");
var _productBox = require("@ori/product-box");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const IconButtons = ({
  shade,
  code,
  price: {
    currentFormatted
  },
  index,
  showBackInStockNotification
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    productName,
    placement,
    mode,
    productListId
  } = (0, _contexts.useShadePicker)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  if (mode === _openShadePicker.ShadePickerMode.Favorites) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_favoritesHeart.FavoritesHeartIconButton, {
      "aria-label": translations.favorites,
      code: code,
      "data-testid": `${getTestId(_constants.FAVORITE)}-${code}`,
      placement: placement,
      position: index,
      productListId: productListId,
      size: "large"
    });
  }
  if (!shade.canBeSold && showBackInStockNotification) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_productBox.NotifyMe, {
      code: code,
      size: "large"
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.QuickBuyButton, {
    currentPrice: currentFormatted,
    name: productName ?? '',
    currentProductCode: code,
    placement: placement,
    position: index,
    disabled: !shade.canBeSold
  });
};
exports.IconButtons = IconButtons;
//# sourceMappingURL=IconButtons.js.map